import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=4ad6c79d&"
import script from "./Answer.vue?vue&type=script&lang=js&"
export * from "./Answer.vue?vue&type=script&lang=js&"
import style0 from "./Answer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports